<!-- 会员等级 -->
<template>
	<div class="wrap">

		<div class="middle-container">

			<div class="main-title-wrap">
				<span class="home-page" @click="$router.push('/')">首页</span>
				<img src="../assets/back-icon.png" class="main-back-icon">
				<span class="current-page">我的权益</span>
			</div>

			<div class="main-wrap">
				<my-sidebar></my-sidebar>

				<div class="rightsidebar">

					<div class="card" :class="{
            'level1': userInfo.member_level === 1,
            'level2': userInfo.member_level === 2,
            'level3': userInfo.member_level === 3,
					}">
						<img src="../assets/avatar.png" class="avatar">
						<div class="card-sidebar">
							<p class="tag-row" v-if="userInfo.member_level === 1">
								<img src="../assets/tag-7.png" />青铜会员
							</p>
							<p class="tag-row" v-if="userInfo.member_level === 2">
								<img src="../assets/tag-8.png" />白银会员
							</p>
							<p class="tag-row" v-if="userInfo.member_level === 3">
								<img src="../assets/tag-9.png" />黄金会员
							</p>
							<p class="name">{{ userInfo.nickname }}</p>
							<p class="tag" v-if="userInfo.member_level > 0">{{ userInfo.vip_enddate }}到期</p>
							<p class="tag" v-else>您还不是VIP会员</p>
						</div>
					</div>

					<ul class="tab-list">
						<li v-for="(item, index) in vipList" :key="index" :class="{active: item.id === buyParams.vid}"
							@click="checkVip(item.id)">
							{{ item.name }}
						</li>
					</ul>

					<div class="bottom-module">
						<p class="bottom-module-label">充值方式</p>
						<ul class="recharge-method-list">
							<li :class="{active: buyParams.spec === 1}"
								@click="buyParams.spec = 1; buyParams.price = vipInfo.month_price">
								<span class="font-1">包月</span>
								<span class="font-2">
									¥<span>{{ vipInfo.month_price }}</span>
								</span>
							</li>
							<li :class="{active: buyParams.spec === 2}"
								@click="buyParams.spec = 2; buyParams.price = vipInfo.quarter_price">
								<span class="font-1">包季</span>
								<span class="font-2">
									¥<span>{{ vipInfo.quarter_price }}</span>
								</span>
								<span
									class="font-3">¥{{ (parseFloat(vipInfo.quarter_price || 0) / 3).toFixed(2) }}/月</span>
							</li>
							<li :class="{active: buyParams.spec === 3}"
								@click="buyParams.spec = 3; buyParams.price = vipInfo.year_price">
								<span class="font-1">包年</span>
								<span class="font-2">
									¥<span>{{ vipInfo.year_price }}</span>
								</span>
								<span
									class="font-3">¥{{ (parseFloat(vipInfo.year_price || 0) / 12).toFixed(2) }}/月</span>
							</li>
						</ul>
						<div class="prompt">
							<p class="prompt-label">会员权益</p>
							<p class="prompt-msg" v-html="vipInfo.content">
								<!--								生日礼包：生日会员专属礼包，所有会员均可享有。<br />-->
								<!--								免费协议：部分功能免费，青铜会员会员可享有。-->
							</p>
						</div>

            <div class="order-msg-module">
              <p class="order-msg-label">支付方式</p>
              <ul class="pay-type-list">
                <li @click="buyParams.type = 'alipay'" :class="{active: buyParams.type === 'alipay' }">
                  <img src="../assets/pay-2.png">支付宝支付
                </li>
                <li @click="buyParams.type = 'wechatpay'" :class="{active: buyParams.type === 'wechatpay' }">
                  <img src="../assets/pay-1.png">微信支付
                </li>
<!--                <li><img src="../assets/pay-4.png">余额支付</li>-->
<!--                <li><img src="../assets/pay-3.png">银联支付</li>-->
              </ul>
            </div>

            <div class="btn-box">
							<button type="button" class="btn" @click="createviporder()">开通</button>
						</div>
					</div>

				</div>
			</div>

		</div>

    <ali-wechat-pay ref="aliWechatPay" @success="getUserInfo()" />
	</div>
</template>

<script>
import {
  MemberlevelService, MemberService
} from "@/common/service";
	import MySidebar from "@/components/my-sidebar";
  import {Message} from "element-ui";
import AliWechatPay from "@/components/ali-wechat-pay";

	export default {
		components: {
      AliWechatPay,
			MySidebar
		},
		data() {
			return {
				vipList: [{
					id: 1,
					name: '铜卡会员',
				}, {
					id: 2,
					name: '银卡会员',
				}, {
					id: 3,
					name: '金卡会员',
				}],
				vipInfo: {},

				buyParams: {
					price: 0, // 价格
					vid: 1, // 购买套餐id
					spec: 1, // 购买套餐规格  1 月套餐  2季度套餐 3年套餐
          type: 'alipay', // wechatpay/alipay
				},
				userInfo: {
					nickname: '',
					headimg: '',
					member_id: 0,
					member_level: 0,
					member_level_name: '',
				},
			};
		},
		mounted() {
      this.getUserInfo().then(() => {
        this.buyParams.vid = Math.max(this.userInfo.member_level, 1);
        this.getMemberVip();
      });
		},
		methods: {
      getUserInfo() {
        return MemberService.info().then(({data}) => {
          this.userInfo = data;
        }).catch(() => {
          this.userInfo = { member_id: 0 };
        }).finally(() => {
          localStorage.setItem('user_info', JSON.stringify(this.userInfo));
        });
      },
			createviporder() {
        if (this.buyParams.vid < this.userInfo.member_level) {
          return Message.warning('不可续费低于当前等级的会员');
        }
				MemberlevelService.createviporder(this.buyParams).then(({ data }) => {
          this.$refs['aliWechatPay'].pay({
            pay_type: this.buyParams.type,
            out_trade_no: data,
            return_url: location.href,
          });
          // Message.success(message);
          // this.getUserInfo();
				});
			},
			checkVip(id) {
				this.buyParams.vid = id;
				this.getMemberVip();
			},
			getMemberVip() {
				MemberlevelService.member_vip({
					id: this.buyParams.vid
				}).then(({
					data
				}) => {
          this.vipInfo = data;
          this.buyParams.price = data.month_price;
        });
			},
		},
	};
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.middle-container {
		width: 100%;
		min-height: calc(100vh - 314px);
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.footer {
		width: 100%;
		height: 271px;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.footer-middle {
		width: calc(1200px - 292px);
		display: flex;
		flex-direction: column;
	}

	.footer-tag-list {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.footer-tag-list>li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.footer-tag-icon {
		width: 56px;
		margin-bottom: 14px;
	}

	.footer-bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 8px;
		box-sizing: border-box;
		margin-top: 37px;
	}

	.footer-bottom-left {
		flex: 1;
		display: flex;
		align-items: center;
		margin-right: 135px;
	}

	.footer-bottom-left-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.footer-bottom-left-list>li {
		width: 33.3333%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		font-size: 16px;
		font-weight: bold;
		margin-top: 15px;
	}

	.footer-bottom-left-list>li:first-child,
	.footer-bottom-left-list>li:nth-child(2),
	.footer-bottom-left-list>li:nth-child(3) {
		margin-top: 0;
	}

	.footer-bottom-right {
		display: flex;
		align-items: center;
	}

	.footer-bottom-right-img {
		width: 48px;
		margin-right: 7px;
	}

	.footer-bottom-right-row {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.footer-font1 {
		color: #C69236;
		font-size: 28px;
		font-weight: bold;
	}

	.footer-font2 {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.middle-container {
		width: 1200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.main-title-wrap {
		width: 100%;
		height: 40px;
		line-height: 40px;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin: 14px 0 9px;
	}

	.home-page {
		font-size: 16px;
		font-weight: bold;
		color: #333333;
	}

	.main-back-icon {
		width: 10px;
		margin: 0 13px;
	}

	.current-page {
		font-size: 16px;
		font-weight: bold;
		color: #333333;
	}

	.main-wrap {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;
	}

	.leftsidebar {
		width: 100px;
		display: flex;
		flex-direction: column;
		margin-right: 10px;
		padding: 20px 0 14px;
		border-radius: 8px;
		background-color: #FFFFFF;
	}

	.leftsidebar>li {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		font-size: 14px;
		font-weight: bold;
		position: relative;
		margin-bottom: 12px;
	}

	.leftsidebar>li:last-child {
		margin-bottom: 0;
	}

	.leftsidebar>li.active {
		color: #333333;
	}

	.leftsidebar>li.active::after {
		content: "";
		background: linear-gradient(180deg, #FF870E, #FF4F06);
		width: 3px;
		height: 20px;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
	}

	.rightsidebar {
		width: calc(100% - 110px);
		display: flex;
		flex-direction: column;
	}

	.tab-list {
		width: 100%;
		height: 38px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		margin-top: 12px;
	}

	.tab-list>li {
		min-width: 105px;
		height: 38px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 5px;
		box-sizing: border-box;
		color: #333333;
		font-size: 14px;
		font-weight: bold;
	}

	.tab-list>li.active {
		color: #FFFFFF;
		background: linear-gradient(90deg, #EC9440, #BA5017);
		border-radius: 8px;
	}

	.box {
		width: 100%;
		display: flex;
		flex-direction: column;
		min-height: 645px;
		background-color: #FFFFFF;
		border-radius: 8px;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 17px 25px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 24px;
	}

	.item-name {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 7px;
	}

	.item-msg {
		color: #333333;
		font-size: 14px;
	}

	.card {
		width: 307px;
		height: 100px;
		background: url(../assets/bg-not-vip.png) no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		padding: 0 12px 0 24px;
		box-sizing: border-box;
	}

	/*1 铜卡会员 2 银卡会员 3 金卡会员*/
	.card.level1 {
		background: url(../assets/bg-4.png) no-repeat;
		background-size: 100% 100%;
	}

	.card.level2 {
		background: url(../assets/bg-3.png) no-repeat;
		background-size: 100% 100%;
	}

	.card.level3 {
		background: url(../assets/bg-level-3.png) no-repeat;
		background-size: 100% 100%;
	}

	.card.level1 .name {
		color: #FFFFFF;
	}

	.card.level1 .tag {
		color: #FFFFFF;
	}

	.card.level2 .name {
		color: #0C5A58;
	}

	.card.level2 .tag {
		color: #0C5A58;
	}

	.card.level3 .name {
		color: #AD6300;
	}

	.card.level3 .tag {
		color: #AD6300;
	}

	.card.level1 .tag-row {
		width: fit-content;
		display: flex;
		align-items: center;
		font-size: 10px;
		color: #FFFFFF;
		border: 1px solid #FFFFFF;
		border-radius: 30px;
		height: 16px;
		line-height: 16px;
		padding: 0 5px;
		margin-bottom: 5px;
	}

	.card.level2 .tag-row {
		width: fit-content;
		display: flex;
		align-items: center;
		font-size: 10px;
		color: #0C5A58;
		border: 1px solid #0C5A58;
		border-radius: 30px;
		height: 16px;
		line-height: 16px;
		padding: 0 5px;
		margin-bottom: 5px;
	}

	.card.level3 .tag-row {
		width: fit-content;
		display: flex;
		align-items: center;
		font-size: 10px;
		color: #AB6200;
		border: 1px solid #AB6200;
		border-radius: 30px;
		height: 16px;
		line-height: 16px;
		padding: 0 5px;
		margin-bottom: 5px;
	}

	.tag-row>img {
		width: 11px;
		margin-right: 2px;
	}

	.avatar {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		margin-right: 17px;
	}

	.card-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.name {
		width: 100%;
		font-size: 16px;
		font-weight: bold;
		/*color: #EEEEEE;*/
    color: #FFFFFF;
		margin-bottom: 9px;
	}

	.tag {
		width: 100%;
		/*color: #999999;*/
    color: #FFFFFF;
		font-size: 12px;
	}

	.bottom-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 39px 34px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		border-radius: 8px;
	}

	.bottom-module-label {
		width: 100%;
		color: #333333;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 14px;
	}

	.recharge-method-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.recharge-method-list>li {
		min-width: 143px;
		height: 96px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-right: 55px;
		margin-bottom: 48px;
		border: 1px solid #979797;
		background-color: #FFFFFF;
		box-sizing: border-box;
		border-radius: 11px;
	}

	.recharge-method-list>li.active {
		border: 1px solid #EDBC7F;
		background-image: radial-gradient(#FFF9F2, #FFE1B9);
	}

	.font-1 {
		color: #333333;
		font-size: 14px;
		font-weight: bold;
	}

	.font-2 {
		color: #333333;
		font-size: 14px;
		font-weight: bold;
	}

	.font-2>span {
		font-size: 24px;
	}

	.font-3 {
		color: #666666;
		font-size: 14px;
	}

	.prompt {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.prompt-label {
		width: 100%;
		color: #333333;
		font-size: 16px;
		margin-bottom: 10px;
	}

	.prompt-msg {
		color: #333333;
		font-size: 14px;
	}

	.btn-box {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 26px;
	}

	.btn {
		width: 112px;
		height: 33px;
		line-height: 33px;
		background-color: #FF6619;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 16px;
		font-weight: bold;
	}


  .order-msg-module {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    padding: 42px 0 0;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .order-msg-label {
    width: 100%;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  .pay-type-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .pay-type-list>li {
    width: fit-content;
    min-width: 147px;
    padding: 0 17px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #999999;
    border-radius: 4px;
    margin-right: 50px;
    color: #333333;
    font-size: 14px;
    background: #FFFFFF;
    box-sizing: border-box;
  }

  .pay-type-list>li>img {
    width: 35px;
    margin-right: 12px;
  }

  .pay-type-list>li.active {
    background: rgba(243, 124, 61, 0.15);
    border: 1px solid #FF6619;
  }

</style>
